import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import AllItems from "../components/Views/AllItems.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import Container from "./Container.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import axios from "axios";

class RoomTypesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("room_types");
        this.getAuxData();
    }

    getBackLink = () => this.datasource.routes().home;

    copy_room_type = (id) =>
        axios
            .get("/manager/data/hotels/copy_room_type/" + id)
            .then((response) => {
                alert(response?.data);
                this.getAllItems();
            })
            .catch((error) => alert(error));

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title="Список категорий номеров"
                        columns={{
                            id: "Id",
                            name: "Наименование",
                            active: "Активен",
                            order: "Порядок",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        copyObject={this.copy_room_type}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        updateParticularItem={this.updateParticularItem}
                        defaultSortfield="order"
                        needViewCopyButton={true}
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новая категория номера"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        defaultRoomFeatures={this.props.auxData?.room_features}
                        defaultRates={this.props.auxData?.rates}
                    />
                </Route>
                <Route path={routes.view(":id")} exact>
                    <ViewForm
                        title="Просмотр категории номера"
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        getHotelUsersLink={this.getHotelUsersLink}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        defaultRoomFeatures={this.props.auxData?.room_features}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relationsDataSource={relationsDataSource}
                        defaultRoomFeatures={this.props.auxData?.room_features}
                        defaultRates={this.props.auxData?.rates}
                        thisRoomType={true}
                    />
                </Route>
            </Switch>
        );
    };
}

export default RoomTypesContainer;
